import React from 'react'
import { Container } from '@scentregroup/ui'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import style from './index.module.scss'

const NoProducts = () => (
  <Container centred className={classNames(style.noProducts)} type="full">
    <div className={style.lead}>We&apos;re Sorry</div>
    <div className={style.main}>No products match this query</div>
    <Link to="/products" className={style.link}>
      See more products
    </Link>
  </Container>
)

export default NoProducts
